(function () {
  function formatMoney(cents, format, currency) {
    if (currency && window.Intl && Intl.NumberFormat) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currency }).format(Math.max(cents, 0) / 100);
      } catch (e) {}
    }
    var value = (Math.max(cents, 0) / 100).toFixed(2);
    var parts = value.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (format || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      if (key === 'amount_no_decimals') return whole;
      return whole + '.' + parts[1];
    });
  }

  function init(root) {
    if (root.dataset.mnReady) return;
    root.dataset.mnReady = '1';
    var dataEl = root.querySelector('[data-product-json]');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var variants = data.variants;
    var form = root.querySelector('[data-mn-form]');
    var mainImg = root.querySelector('.mn-gallery__img');
    var thumbs = root.querySelectorAll('.mn-gallery__thumb');
    var atc = root.querySelector('[data-atc]');
    var atcText = root.querySelector('[data-atc-text]');
    var errorEl = root.querySelector('[data-error]');
    var peopleBox = root.querySelector('[data-people]');
    var people = root.querySelectorAll('[data-person]');
    var offers = root.querySelectorAll('.mn-offer');
    var selected = variants.find(function (v) { return v.id === data.selectedId; }) || variants[0];
    var current = selected.options.slice();
    var qty = 1;
    var discount = 0;
    // Bundle discounts are set in the store currency (USD). When a shopper sees
    // another currency, convert them with Shopify's live rate, like checkout does.
    var rate = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
    var foreign = data.currency && data.shopCurrency && data.currency !== data.shopCurrency;
    if (!foreign) rate = 1;
    var fmtCurrency = foreign ? data.currency : null;
    function money(c) { return formatMoney(c, data.moneyFormat, fmtCurrency); }
    function offerDiscount(o) { return Math.round((Number(o.dataset.discount) || 0) * rate); }

    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function setImage(mediaId) {
      if (!mainImg || !mediaId) return;
      var m = data.media.find(function (x) { return x.id === mediaId; });
      if (!m) return;
      mainImg.removeAttribute('srcset');
      mainImg.src = m.src;
      thumbs.forEach(function (t) { t.classList.toggle('is-active', Number(t.dataset.mediaId) === mediaId); });
    }

    function personVariant(row) {
      var opts = (selected || variants[0]).options.slice();
      row.querySelectorAll('[data-person-option]').forEach(function (sel) {
        opts[Number(sel.dataset.personOption)] = sel.value;
      });
      return findVariant(opts);
    }

    // All variants in the order: person 1 (main pickers), person 2..qty
    function chosenVariants() {
      var list = [selected];
      people.forEach(function (row) {
        if (Number(row.dataset.person) <= qty) list.push(personVariant(row));
      });
      return list;
    }

    function render() {
      selected = findVariant(current);
      var priceEl = root.querySelector('[data-price]');
      var compareEl = root.querySelector('[data-compare]');
      var saveEl = root.querySelector('[data-save]');

      root.querySelectorAll('.mn-pills').forEach(function (group) {
        var idx = Number(group.dataset.optionIndex);
        group.querySelectorAll('.mn-pill').forEach(function (pill) {
          pill.classList.toggle('is-active', pill.dataset.value === current[idx]);
          var test = current.slice();
          test[idx] = pill.dataset.value;
          var tv = findVariant(test);
          pill.classList.toggle('is-unavailable', !tv || !tv.available);
        });
        var label = root.querySelector(group.dataset.role === 'color' ? '[data-color-label]' : '[data-size-label]');
        if (label) label.textContent = current[idx];
      });

      if (!selected) {
        atc.disabled = true;
        atcText.textContent = 'Unavailable';
        return;
      }

      var list = chosenVariants();
      var p1 = root.querySelector('[data-person-one]'); if (p1) p1.textContent = selected.options.join(' · '); var missing = list.some(function (v) { return !v || !v.available; });
      var sum = 0;
      list.forEach(function (v) { if (v) sum += v.price; });

      // Single-item price shown on the 1-onesie card
      offers.forEach(function (o) {
        var n = Number(o.dataset.offer);
        var p = o.querySelector('[data-offer-price]');
        var c = o.querySelector('[data-offer-compare]');
        if (n === 1) {
          p.textContent = money(selected.price);
          if (selected.compare_at_price > selected.price) {
            c.textContent = money(selected.compare_at_price);
            c.hidden = false;
          } else {
            c.hidden = true;
          }
        } else {
          var d = offerDiscount(o);
          var full = (n === qty && !missing) ? sum : data.priceMax * n;
          p.textContent = money(full - d);
          c.textContent = money(full);
          var sv = o.querySelector('[data-offer-save]');
          if (sv) sv.textContent = money(d);
        }
      });

      if (qty > 1) {
        var total = sum - discount;
        priceEl.textContent = money(total);
        compareEl.textContent = money(sum);
        compareEl.hidden = false;
        saveEl.textContent = 'SAVE ' + Math.round((discount / sum) * 100) + '%';
        saveEl.hidden = false;
      } else {
        priceEl.textContent = money(selected.price);
        if (selected.compare_at_price && selected.compare_at_price > selected.price) {
          compareEl.textContent = money(selected.compare_at_price);
          compareEl.hidden = false;
          saveEl.textContent = 'SAVE ' + Math.round((1 - selected.price / selected.compare_at_price) * 100) + '%';
          saveEl.hidden = false;
        } else {
          compareEl.hidden = true;
          saveEl.hidden = true;
        }
      }
      var stickyPrice = root.querySelector('[data-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = priceEl.textContent;

      atc.disabled = !selected.available;
      atcText.textContent = selected.available ? data.atcText : 'Sold out';
      if (selected.featured_media) setImage(selected.featured_media.id);
      if (window.location.pathname.indexOf('/products/') !== -1 && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', selected.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    root.querySelectorAll('.mn-pills').forEach(function (group) {
      group.addEventListener('click', function (e) {
        var pill = e.target.closest('.mn-pill');
        if (!pill) return;
        current[Number(group.dataset.optionIndex)] = pill.dataset.value;
        render();
      });
    });

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { setImage(Number(t.dataset.mediaId)); });
    });

    offers.forEach(function (offer) {
      offer.addEventListener('change', function () {
        qty = Number(offer.dataset.offer);
        discount = offerDiscount(offer);
        offers.forEach(function (o) { o.classList.toggle('is-active', o === offer); });
        if (peopleBox) peopleBox.hidden = qty < 2;
        people.forEach(function (row) { row.hidden = Number(row.dataset.person) > qty; });
        render();
      });
    });

    people.forEach(function (row) {
      row.addEventListener('change', render);
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!selected || !selected.available) return;
      errorEl.hidden = true;
      var list = chosenVariants();
      for (var i = 0; i < list.length; i++) {
        if (!list[i] || !list[i].available) {
          errorEl.textContent = 'The size/color picked for person ' + (i + 1) + ' is sold out — please choose another.';
          errorEl.hidden = false;
          return;
        }
      }
      var byId = {};
      var order = [];
      list.forEach(function (v) {
        if (!byId[v.id]) { byId[v.id] = 0; order.push(v.id); }
        byId[v.id] += 1;
      });
      var items = order.map(function (id) { return { id: id, quantity: byId[id] }; });

      atc.classList.add('is-loading');
      atc.disabled = true;
      var drawer = document.querySelector('cart-drawer');
      var body = { items: items };
      if (drawer && drawer.getSectionsToRender) body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) {
            errorEl.textContent = res.description || res.message || 'Could not add to cart.';
            errorEl.hidden = false;
            return;
          }
          if (drawer && res.sections) {
            drawer.classList.remove('is-empty');
            drawer.renderContents(res);
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(function () {
          errorEl.textContent = 'Something went wrong. Please try again.';
          errorEl.hidden = false;
        })
        .finally(function () {
          atc.classList.remove('is-loading');
          atc.disabled = !(selected && selected.available);
        });
    });

    // Size guide
    var dlg = root.querySelector('[data-sizeguide]');
    var openSg = root.querySelector('[data-open-sizeguide]');
    if (dlg && openSg) {
      openSg.addEventListener('click', function () { dlg.showModal ? dlg.showModal() : dlg.setAttribute('open', ''); });
      root.querySelector('[data-close-sizeguide]').addEventListener('click', function () { dlg.close(); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    }

    // Sticky bar
    var sticky = root.querySelector('[data-sticky]');
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var en = entries[0];
        sticky.hidden = en.isIntersecting || en.boundingClientRect.top > 0;
      }).observe(atc);
      root.querySelector('[data-sticky-btn]').addEventListener('click', function () {
        atc.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    render();
  }

  function boot() {
    document.querySelectorAll('.mn-product').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
